import "./dot-loading.css";
import { DotLoading } from './dot-loading';
export default DotLoading;